import { produce } from 'immer';

import { AddInternalBannerImage } from '../../../actions/imageEditor/internal/addInternalBannerImage';
import { getEmptyBannerImage } from '../../../service/BannerHelpers/BannerHelpers';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function addInternalBannerImage(state: ImageEditorsState, action: AddInternalBannerImage): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        if (!draft[id]) {
            draft[id] = {
                image: getEmptyBannerImage(),
                isImageCanvasOpen: false,
                imageGallery: {
                    images: undefined,
                    isImageGalleryOpen: false,
                    selectedImageHashFromGallery: []
                },
                imageUploadingLink: ''
            };
        }
    });
}
